<template>
  <div>
    <div class="step-header">
      <small>Etapa 2 de 5</small>
      <h5>Dados de endereço</h5>
      <small>Atenção: Com exceção do complemento, TODOS os campos são obrigatórios.</small>
    </div>

    <b-form-group class="w-100 mt-1">
      <input
        type="text"
        v-model="cep"
        required="required"
        v-mask="'#####-###'"
        v-on:change="buscaCep(cep)"
      />
      <!-- v-on:change="updateValue($event, 'cep')" -->
      <label for="input" class="control-label" style="font-size: 90%;">CEP*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        id="address"
        type="text"
        :value="address"
        required="required"
        v-on:change="updateValue($event, 'address')"
        :disabled="loadingCep"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Endereço*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        id="number"
        type="text"
        :value="number"
        required="required"
        v-on:change="updateValue($event, 'number')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Número*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        type="text"
        :value="neighborhood"
        required="required"
        v-on:change="updateValue($event, 'neighborhood')"
        :disabled="loadingCep"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Bairro*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        type="text"
        :value="complement"
        required="required"
        v-on:change="updateValue($event, 'complement')"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Complemento</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        type="text"
        :value="city"
        required="required"
        v-on:change="updateValue($event, 'city')"
        :disabled="loadingCep"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Cidade*</label>
      <i class="bar"></i>
    </b-form-group>

    <b-form-group class="w-100 mt-1">
      <input
        type="text"
        :value="uf"
        required="required"
        v-on:change="updateValue($event, 'uf')"
        :disabled="loadingCep"
      />
      <label for="input" class="control-label" style="font-size: 90%;">Estado*</label>
      <i class="bar"></i>
    </b-form-group>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { VueMaskDirective } from "v-mask";
import cep from "cep-promise";

export default {
  directives: {
    mask: VueMaskDirective
  },

  props: [
    "cep",
    "address",
    "number",
    "neighborhood",
    "complement",
    "city",
    "uf"
  ],
  data: () => {
    return {
      loadingCep: false
    };
  },
  methods: {
    updateValue(event, data) {
      this.$emit(`update:${data}`, event.target.value);
    },
    buscaCep(zipcode) {
      this.loadingCep = true;
      cep(zipcode)
        .then(res => {
          this.loadingCep = false;
          setTimeout(() => {
            document.getElementById("number").focus();
          });
          this.$emit("update:cep", zipcode);
          this.$emit("update:address", res.street);
          this.$emit("update:neighborhood", res.neighborhood);
          this.$emit("update:city", res.city);
          this.$emit("update:uf", res.state);
        })
        .catch(err => {
          this.$emit("update:cep", zipcode);
          this.$emit("update:address", "");
          this.$emit("update:neighborhood", "");
          this.$emit("update:city", "");
          this.$emit("update:uf", "");
          setTimeout(() => {
            document.getElementById("address").focus();
          });
          this.loadingCep = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.step-header {
  margin-bottom: 30px;
}
</style>
